import React, { useState, useEffect } from "react";
import OptimizedImage from "./OptimizedImage";
import "./ProfessionGallery.css";

const professions = [
  {
    name: "Nurse",
    img: process.env.PUBLIC_URL + "/nurse.webp",
    srcSet: `${process.env.PUBLIC_URL}/nurse.webp 313w`,
    sizes: "54px",
    title: "Prometric certification for DHA, DHP, MOHKW, NHRA, and SCFHS nursing examinations.",
    alt: "Prometric-certified nurse with a DHA, DHP, MOHKW, NHRA, and SCFHS certificate"
  },
  {
    name: "Pharmacist",
    img: process.env.PUBLIC_URL + "/pharmacist.webp",
    title: "Prometric certification for DHA, DHP, MOHKW, NHRA, and SCFHS pharmacy examinations.",
    alt: "Prometric-certified Pharmacist with a DHA, DHP, MOHKW, NHRA, and SCFHS certificate"
  },
  {
    name: "Doctor",
    img: process.env.PUBLIC_URL + "/doctor.webp",
    title: "Prometric certification for DHA, DHP, MOHKW, NHRA, and SCFHS medical examinations.",
    alt: "Prometric-certified doctor with a DHA, DHP, MOHKW, NHRA, and SCFHS certificate"
  },
  {
    name: "Dentist",
    img: process.env.PUBLIC_URL + "/dentist.webp",
    title: "Prometric certification for DHA, DHP, MOHKW, NHRA, and SCFHS dental examinations.",
    alt: "Prometric-certified dentist with a DHA, DHP, MOHKW, NHRA, and SCFHS certificate"
  },
  {
    name: "Physiotherapist",
    img: process.env.PUBLIC_URL + "/physical-therapist.webp",
    title: "Prometric certification for DHA, DHP, MOHKW, NHRA, and SCFHS physiotherapy examinations.",
    alt: "Prometric-certified Physiotherapist with a DHA, DHP, MOHKW, NHRA, and SCFHS certificate"
  },
];

const ProfessionGallery = () => {
  const [colorMode, setColorMode] = useState('light');

  useEffect(() => {
    // Check localStorage for color mode
    const checkColorMode = () => {
      const storedMode = localStorage.getItem('chakra-ui-color-mode');
      setColorMode(storedMode || 'light');
    };

    // Initial check
    checkColorMode();

    // Listen for storage changes
    window.addEventListener('storage', checkColorMode);

    // Also check periodically in case localStorage changes without storage event
    const interval = setInterval(checkColorMode, 100);

    return () => {
      window.removeEventListener('storage', checkColorMode);
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="profession-gallery-section dark-mode-support">
      <h2
        className="profession-gallery-heading"
        style={{
          color: colorMode === 'dark' ? '#ffffff' : '#000000',
          fontSize: '2rem',
          fontWeight: '700',
          marginBottom: '32px',
          textAlign: 'center',
          letterSpacing: '0.01em',
          transition: 'color 0.2s'
        }}
      >
        Healthcare Professionals
      </h2>
      <div className="profession-gallery-grid">
        {professions.map((prof, idx) => (
          <div className="profession-card profession-card-dark" key={prof.name}>
            <OptimizedImage
              src={prof.img}
              srcSet={prof.srcSet}
              alt={prof.alt}
              className="profession-img large-img"
              width="120"
              height="120"
              sizes={prof.sizes || "120px"}
              title={prof.title || prof.name}
              style={{
                aspectRatio: '1',
                objectFit: 'contain'
              }}
            />
            <div className="profession-desc">{prof.name}</div>
            <div className="profession-title-text">{prof.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProfessionGallery;
